import React, { useState, useEffect } from "react";
import API from "../axios";
import "../App.css"
import casual from "../assets/casual.png"
import sick from "../assets/sick.png"
import earn from "../assets/earn.png"
import defaultCal from "../assets/defaultCalendar.png"

const Leave = () => {
  const [data, setData] = useState([]);
  const [leaveDate, setLeaveDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

  // ✅ Fetch Leave Data
  const fetchLeave = async () => {
    try {
      setLoading(true);

      const res = await API.post("/leave", {   // ✅ correct API
        empcode: empDetails.employee_code
      });

      console.log(res.data);

      setData(res.data.leaves);
      setLeaveDate(res.data.leaveDate);
    } catch (err) {
      console.error("Error fetching leaves", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Load on page
  useEffect(() => {
    if (empDetails?.employee_code) {
      fetchLeave();   // ✅ correct function
    }
  }, []);

  const getLeaveIcon = (type) => {
  const t = type?.toLowerCase();

  if (t.includes("casual")) return casual;
  if (t.includes("sick")) return sick;
  if (t.includes("earn")) return earn;

  return defaultCal; // fallback
};

  return (
    <div className="container mt-3 pt-lg-5">

      <h3 className="mb-3 titlepage">Leave Balance</h3>

      {/* TABLE */}
      <div className="table-responsive attendance-scroll">
        <p>
          Updated On: {leaveDate
            ? new Date(leaveDate).toLocaleDateString("en-GB")
            : "N/A"}
        </p>

        <table className="table text-center attendance-table">
          <thead>
            <tr>
              <th>Leave Type</th>
              <th>Credit</th>
              <th>Used</th>
              <th>Balance</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="fw-bold">
                  Loading...
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index}>
                  {/* <td>{item.LeaveType}</td> */}
                  <td className="d-flex align-items-center gap-2 text-center  justify-content-center" >
                    <img 
                    className="me-lg-3 leaveimg"
                      src={getLeaveIcon(item.LeaveType)} 
                      alt="icon" 
                    />
                    <label className="text-start leaveTxt">{item.LeaveType}</label>
                    
                  </td>
                  <td>{item.Credit}</td>
                  <td>{item.Used}</td>
                  <td>{item.Balance}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-dark fw-bold">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default Leave;